import { Box, Button, ConfirmDialog } from "designSystem/index";
import React, { useState } from "react";

export default () => {
	const [open, setOpen] = useState(false);
	const onClose = () => setOpen(false);
	const onButton = () => setOpen(true);

	return (
		<Box>
			<Button design="primary" onClick={onButton}>
				Button with Confirmation
			</Button>
			<ConfirmDialog
				category="warn"
				confirmRes="ConfirmButton"
				messageRes="ConfirmMessage"
				messageResParams={["Style"]}
				onCancel={() => console.log("Action cancelled")}
				onClose={onClose}
				onConfirm={() => console.log("Action confirmed")}
				open={open}
				titleRes="ConfirmPrompt"
				titleResParams={["Style"]}
			/>
		</Box>
	);
};